import * as React from 'react';
import { BACKGROUND_COLOR, COLOR_A, COLOR_B } from './CONSTANTS';
import { rgbToHsl } from './utilities.js';

const COLOR_A_HSL = rgbToHsl(COLOR_A);

class SourceDisplay extends React.Component {
	constructor(props) {
		super(props);
		this.canvas = React.createRef();
	}

	componentDidUpdate() {
		this.draw();
	}

	draw() {
		const { buffer, sourceStart, sourceEnd, sampleRate, loadProgress } = this.props;
		const canvas = this.canvas.current;
		const height = canvas.height;
		const width = canvas.width;
		const context = canvas.getContext('2d');
		// context.scale(dpr, dpr);

		context.globalAlpha = 0.8;

		const topPaddingRatio = 0.25;
		const topPadding = height * topPaddingRatio;
		const figureHeight = height * (1 - topPaddingRatio);

		context.lineWidth = 1;
		// context.strokeStyle = '#000000';
		context.clearRect(0, 0, width, height);

		context.fillStyle = BACKGROUND_COLOR;

		context.fillRect(0, 0, width, height);

		context.lineJoin = 'round';

		const startX = sourceStart * width;
		const endX = sourceEnd * width;

		var grd = context.createLinearGradient(0, topPadding, 0, height);
		grd.addColorStop(0, COLOR_A);
		grd.addColorStop(1, 'rgba(255, 255, 255, 0)');

		var grd2 = context.createLinearGradient(0, height / 2, 0, height);
		grd2.addColorStop(1, COLOR_B);
		grd2.addColorStop(0, BACKGROUND_COLOR);

		// context.fillStyle = COLOR_A;
		context.fillStyle = COLOR_A;
		if (loadProgress < 1) {
			context.fillRect(0, 0, width * loadProgress, height);
		} else {
			if (buffer) {
				const bufferBit = buffer.getChannelData(0);
				const interval = Math.floor(bufferBit.length / width);
				var oldY = bufferBit[0];
				context.beginPath();
				context.moveTo(0, height);
				const alpha = 0.1;
				for (var x = 0; x < width; x++) {
					var y = alpha * Math.abs(bufferBit[interval * x] * height) + (1 - alpha) * oldY;

					if (x < startX || x > endX) {
						context.fillStyle = COLOR_A;
					} else {
						context.fillStyle = grd;
					}
					// context.lineTo(x, height / 2 - y);
					context.fillRect(x, height / 2 - y * 2, 1, 2 * y * 2);

					oldY = y;
				}
			}
		}
	}

	render() {
		return (
			<canvas
				style={{ width: '100%', height: '100%' }}
				// width={this.props.width}
				// height={this.props.height}
				ref={this.canvas}
			/>
		);
	}
}

export default SourceDisplay;
